<template>
  <v-dialog
    v-model="dialogState"
    :max-width="width"
    @keydown.esc="onEscPushed"
    @click:outside="onOutsideClicked"
  >
    <v-card :loading="cardLoading">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          text
          color="primary"
          @click="onNoClicked"
          :disabled="cardLoading"
        >
          {{ noActionName }}
        </v-btn>
        <v-btn color="primary" @click="onYesClicked" :disabled="cardLoading">
          {{ yesActionName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    dialogOpen: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: false,
      default: 500
    },
    dialogLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    yesActionName: {
      type: String,
      required: false,
      default: 'Yes'
    },
    noActionName: {
      type: String,
      required: false,
      default: 'No'
    }
  },
  data: () => {
    return {
      dialogState: false,
      cardLoading: false
    }
  },
  methods: {
    onEscPushed() {
      this.$emit('escPushed')
    },
    onNoClicked() {
      this.$emit('noClicked')
    },
    onYesClicked() {
      this.$emit('yesClicked')
    },
    onOutsideClicked() {
      // This emitted event have to implement on parent component.
      // Otherwise dialog doesn't open again when user clicked outside area of dialog.
      this.$emit('outsideClicked')
    }
  },
  watch: {
    dialogOpen: function(newVal) {
      this.dialogState = newVal
    },
    dialogLoading: function(newVal) {
      console.log('loading loaded')
      console.log(newVal)
      this.cardLoading = newVal
    }
  }
}
</script>

<style scoped></style>
